import { useState } from 'react';
import {
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalBody,
	ModalCloseButton,
	Spinner,
	chakra,
	Text,
	Center,
} from '@chakra-ui/react';

const VideoModal = ({ videoUrl, triggerText = "Watch video" }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isVideoLoaded, setIsVideoLoaded] = useState(false);

	return (
		<>
			<Text align="center">
				Need Help?{' '}
				<chakra.span color="#FF5733" _hover={{ textDecoration: "underline" }} onClick={onOpen} cursor={"pointer"}>
					Watch Our Minting Guide
				</chakra.span>
			</Text>

			<Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
				<ModalOverlay />
				<ModalContent>
					<ModalCloseButton zIndex={100} />
					<ModalBody p={2}>
						<>
							{!isVideoLoaded && <Center><Spinner /></Center>}
							<video
								width="100%"
								height="100%"
								controls
								onLoadedData={() => setIsVideoLoaded(true)}
							>
								<source src={videoUrl} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
						</>

					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
};

export default VideoModal;
